
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../BaseButton";
import UIButton from "../components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnPauseClose extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 26.5, y ?? 27);

    // btn_close_png
    const btn_close_png = scene.add.image(0, 0, "common", "btn-close.png");
    this.add(btn_close_png);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
